import { useI18nContext } from '@tmsw/powerups.intl.provider';
import type { LocaleID } from '@tmsw/powerups.intl.provider';

export function globalizedMedia(filename: string, folder: string) {
  const locale = 'global';
  if (!filename) { console.trace('Missing file ', filename); return ''; }
  folder = typeof folder === 'undefined' ? 'img' : folder;
  return (filename.substring(0, 8) === './static') ? filename : [
    './',
    'static/media',
    locale, folder, filename
  ].join('/').replace('//', '/');
}

export function localizedMedia(filename: string, folder: string, locale: LocaleID):string {
  if (!filename) { console.trace('Missing file ', filename); return ""; }
  folder = typeof folder === 'undefined' ? 'img' : folder;
  return (filename.substring(0, 8) === './static') ? filename : [
    './',
    'static/media',
    locale, folder, filename
  ].join('/').replace('//', '/');
}

export function useLocalizedMedia(filename:string, folder:string) {
  const i18n = useI18nContext();
  console.log('i18n', i18n);
  const locale = i18n.locale || i18n.fallbackLocale;
  return localizedMedia(filename, folder, locale);
}

export default useLocalizedMedia;